<template>
	<div class="tab-page">
		<form @submit.prevent="login" ref="form">
			<div class="field">
				<div class="container">
					<div class="content">
						<div class="field-inner">
							<label for="company-code">{{$t('company-code')}}</label>
							<div class="element">
								<input type="text" placeholder=" " v-model="companyCode" id="company-code" required>
							</div>
							<label for="password">{{$t('password')}}</label>
							<div class="element">
								<input type="password" placeholder=" " v-model="password" id="password" required>
							</div>
							<div class="element">
								<label for="remember-me"><input type="checkbox" id="remember-me" v-model="rememberMe">{{$t('remember-me')}}</label>
							</div>
							<div class="element">
								<router-link :to="{name: 'registration'}">{{$t('forgot-password-?')}}</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr>
			<div class="container">
				<div class="content">
					<button>{{$t('enter')}}</button>
				</div>
			</div>
		</form>
		<div class="container">
			<div class="content">
				<p class="reserved-area-message">{{$t('reserved-area-message')}}</p>
			</div>
		</div>

	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'Login',
	data() {
		return {
			companyCode: '',
			password: '',
			rememberMe: false,
			loginError: false,
		}
	},
	mounted() {
		if (this.$store.getters.isAuthenticated) {
			this.$router.push({name: 'account'});
		}
	},
	methods: {
		login () {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			this.loginError = false;

			const data = {
				code: this.companyCode,
				password: this.password,
				rememberMe: this.rememberMe
			};

			var self = this;
			this.$store.dispatch('authRequest', data)
			.then(() => {
				self.$snack.success({button: null, text: self.$i18n.t('connected')});
				self.$router.push(self.$route.query.redirect || {name: 'account'});
			})
			.catch((err) => {
				self.loginError = true;
				if (err.message === 'Network Error') {
					self.$snack.danger({button: null, text: self.$i18n.t('network-error')});
				} else {
					self.$snack.danger({button: null, text: self.$i18n.t('authentication-error')});
				}
				if (navigator.vibrate){
					navigator.vibrate([500]);
				}
			});
		}
	}
}
</script>

<style scoped>
	.reserved-area-message {
		margin-top: 1.6rem;
	}
</style>